import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes } from 'react-router-dom';

const SalePage = loadable(
  () => import(/* webpackChunkName: "SalePage" */ './pages/SalePage/SalePage')
);

const MobileAppPage = loadable(
  () => import(/* webpackChunkName: "MobileAppPage" */ './pages/MobileAppPage/MobileAppPage')
);

export enum PAGES {
  SALE_PAGE = 'SALE_PAGE',
  MOBILE_APP = 'MOBILE_APP',
}

/**
 * Util used on SSR to determine which Sparrow QUERY to use
 * @param path
 * @returns pageType
 */
export const getPage = (path: string) => {
  switch (/.*\/([^?]+)/.exec(path)?.[1]) {
    case 'sale-preferences':
    case 'sale-offers':
      return PAGES.MOBILE_APP;
    default:
      return PAGES.SALE_PAGE;
  }
};

const AppRouter = () => {
  return (
    <Routes>
      <Route path=":slug?/sale-hotel" element={<SalePage />} />
      <Route path=":slug?/sale-preferences" element={<MobileAppPage />} />
      <Route path=":slug?/sale-offers" element={<MobileAppPage />} />
    </Routes>
  );
};

export default AppRouter;
